import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/infoBold.svg';

export const IconInfoBold = createIconComponent(Icon);
